"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.setPractice = exports.setApplicationEnvironment = exports.setPersonalInfo = exports.clearApplicationEnvironment = exports.clearApplicant = void 0;
const redux_actions_1 = require("redux-actions");
exports.clearApplicant = (0, redux_actions_1.createAction)('CLEAR_APPLICANT');
exports.clearApplicationEnvironment = (0, redux_actions_1.createAction)('CLEAR_APPLICATION_ENVIRONMENT');
exports.setPersonalInfo = (0, redux_actions_1.createAction)('CREDIT_APPLICATION/SET_PERSONAL_INFO');
exports.setApplicationEnvironment = (0, redux_actions_1.createAction)('SET_APPLICATION_ENVIRONMENT');
exports.setPractice = (0, redux_actions_1.createAction)('CREDIT_APPLICATION/SET_PRACTICE');
